import { TableColumn } from 'react-data-table-component';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import dayjs from 'dayjs';

import VisitLinkCell from './Cells/VisitDocLinkCell';

import { Breakpoints } from 'hooks/Screen/useScreenSize';
import { DigestReportData } from 'api/digestReports/getDigestReports';
import { useDigestDeleteModalStore } from 'pages/DigestReports/Modals/DeleteDigestModal/DigestDeleteStore';

export const useGetDigestReportListTableColumns = (
  slug: string,
  refetchPeriodReports: () => void,
  data: DigestReportData[],
): TableColumn<DigestReportData>[] => {
  const { t } = useTranslation();
  const { openDeleteDigestModal } = useDigestDeleteModalStore();

  return [
    {
      name: t('DigestReportList.tableTitles.createData'),
      selector: row => (row?.datetime ? dayjs(row.datetime).format('YYYY-MM-DD\xa0\xa0\xa0HH:mm') : '-'),
    },
    {
      name: t('DigestReportList.tableTitles.document'),
      selector: row => row.id,
      cell: row => {
        if (!row.created_by) {
          return (
            <button className="btn btn-ghost-warning" disabled>
              <i className="ri-loader-2-line ri-spin" /> Loading...
            </button>
          );
        }

        return (
          <div>
            {row.status === 'error' ? (
              <button
                className="btn btn-ghost-danger"
                onClick={e => {
                  e.preventDefault();
                  enqueueSnackbar(t('DigestReportList.tableTitles.errorStatusTable'), { variant: 'error' });
                }}
              >
                <i className="ri-error-warning-line fs-16" />{' '}
              </button>
            ) : (
              <VisitLinkCell link={`/digest-report/${slug}/${row.id}/`} icon="ri-treasure-map-line" />
            )}
          </div>
        );
      },
    },
    {
      name: t('DigestReportList.tableTitles.createdBy'),
      selector: row => row.created_by.username,
      hide: Breakpoints.Desktop,
    },
    {
      name: t('DigestReportList.tableTitles.actions'),
      cell: _row => (
        <div
          className="btn btn-ghost-info"
          onClick={() =>
            openDeleteDigestModal(slug, refetchPeriodReports, data.find(item => item.id === _row.id)?.id || 0)
          }
        >
          <i className="ri-delete-bin-6-fill icon icon__delete" />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
};
